import i18n from 'i18next'
import LanguageDetector, { CustomDetector } from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

// if we want to always show one language as default, no matter what the browser says
// if you want to use the browser language, just remove the CustomDetector in the detection options
export const defaultLanguage = 'de'

const myDetector: CustomDetector = {
  name: 'myDetectorsName',

  lookup() {
    return defaultLanguage
  },
}

const languageDetector = new LanguageDetector()
languageDetector.addDetector(myDetector)

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(languageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    detection: { order: ['myDetectorsName'] },
    debug: false,
    fallbackLng: defaultLanguage,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          header: {
            title: `${import.meta.env.VITE_SITE_NAME}`,
            slogan: `I am Alva. I provide information about the contents on <1>${import.meta.env.VITE_MAIN_SITE_SHORT}</1>`,
            intro: `
            My answers are generated by artificial intelligence and are therefore not always correct. Your feedback helps to improve me.
            <br /><br />We are grateful for any <1>feedback.</1>`,
          },
          from: 'from',
          question: {
            label: 'Your Question',
            placeholder: 'Ask me anything about the administration of the Canton of Basel-Stadt.',
            buttonText: 'Ask Question',
            microphoneLabel: 'Ask Question (with Microphone)',
            microphoneListening: 'Microphone: Hold down the button and speak',
          },
          answers: {
            oneMoment: 'One moment please... ',
            serverConnectionError: 'Connection to the server lost :( Please try again soon.',
            otherModelButton: 'Try with more context (experimental)',
            wasItUseful: 'Was the answer useful?',
            yes: 'Yes',
            no: 'No',
            giveFeedback: 'Give Feedback',
            readHints: 'Read Hints and Limitations',
            letsTryToImprove: "Let's try to improve the answer!",
            improvePrompt: 'Refine your question and try again',
            thanksForFeedback: 'Thanks for your feedback!',
            happy: 'Happy with the answer',
            unhappy: 'Unhappy with the answer',
            not_considered_articles: 'Links not considered for the answer (but possibly still relevant):',
            considered_articles: 'Links considered for the answer:',
            answer: 'Answer',
            searchresults: 'Search Results',
          },
          hints: {
            title: 'Hints and Limitations',
            notesTitle: 'Hints',
            intro:
              'Diese Applikation wurde entwickelt, um Ihnen bei allgemeinen Fragen zur Verwaltungstätigkeit des Kantons Basel-Stadt zu helfen. Die Antworten werden von einer künstlichen Intelligenz generiert und sind deshalb nicht immer korrekt und vollständig. Bitte lesen Sie vorgängig die Nutzungsbedingungen sowie die Datenschutzerklärung. Durch die Nutzung der Applikation erklären Sie sich mit den Nutzungsbedingungen und der Datenschutzerklärung einverstanden. Wir freuen uns über jedes Feedback. ',
            note1: 'This is an experimental version of this application, which is continuously being improved.',
            note2: 'All information provided without guarantee.',
            note3:
              'Please verify the information from Alva on the official websites of the Canton of Basel-Stadt [www.bs.ch](http://bs.ch).',
            note4:
              'Alva sends your questions via an interface to ChatGPT from OpenAI. If you have any concerns about data privacy, please refrain from using the assistant.',
            note5:
              'Alva cannot address your individual situation but generates answers based on publicly accessible content from the Canton of Basel-Stadt. For personal information, please contact the staff of the Canton.',
            note6:
              'Alva does not remember previously asked questions. For refinements, the question must be entered again.',
            note7:
              'It is better to ask complete questions rather than just entering keywords. Sometimes rephrasing a question can help to get a better answer.',
            note8: 'If no answer is provided or the answer ends abruptly, please try again.',
            note9:
              'We are continuously working to improve this application. Therefore, we save your questions and answers and evaluate them in the background.',
            note10: 'We greatly appreciate any feedback you provide; it helps us tremendously.',
            note11: '[Privacy Policy](/privacy)',
            limitationsTitle: 'Limitations',
            limitationsText: `Renewal WebBS: Quality assurance Alva knows (almost) everything that was published on <1>${
              import.meta.env.VITE_MAIN_SITE_SHORT
            }</1> as of {{lastUpdate}}.`,
            disclaimerText:
              'The answers from Alva are not legally binding and there is no guarantee for the accuracy, completeness, or timeliness of the provided information.',
          },
          contact: {
            title: 'Contact and Feedback',
            emailLabel: 'Your E-Mail (optional):',
            messageLabel: 'Your message:',
            submitButton: 'Submit',
            feedbackReceived: 'Feedback received, thank you!',
            feedbackReceivedError: 'Error while sending feedback, please try the other means to reach us.',
            emailText: 'Oder senden Sie einsend ann email at chregu@liip.ch',
            moreContact: 'More contact options at',
          },
          footer: {
            credits: 'Powered by <1>Liip</1> — <3>Blog Post about the project</3>',
            disclaimer: `All information without guarantee. Please check the information on the official website of Basel City.`,
            selectLanguage: 'Select Language',
          },
        },
      },
      de: {
        translation: {
          header: {
            title: `${import.meta.env.VITE_SITE_NAME}`,
            slogan: `<0>Ich bin Alva. </0><1>Ich beantworte Ihre Fragen zur Verwaltung des Kantons </1><2>Basel-Stadt.</2>`,
            intro: `Meine Antworten werden von einer künstlichen Intelligenz generiert und sind deshalb nicht immer korrekt. Ihre Rückmeldungen helfen dabei, mich zu verbessern.
            <br /><br />Wir freuen uns darum über jedes <1>Feedback.</1>`,
          },
          from: 'vom',
          question: {
            label: 'Deine Frage',
            placeholder: 'Fragen Sie mich etwas über die Verwaltung von Basel-Stadt.',
            placeholderMobile: 'Fragen Sie mich etwas.',
            buttonText: 'Frage stellen',
            microphoneLabel: 'Frage stellen (mit Mikrofon)',
            microphoneListening:
              'Mikrofon: Halten Sie den Knopf gedrückt und sprechen Sie. Schweizerdeutsch geht auch. Meistens.',
          },
          results: {
            initial: ``,
            initialEmpty: ``,
          },
          answers: {
            oneMoment: 'Einen Moment bitte... ',
            serverConnectionError: 'Verbindung zum Server abgebrochen :( Bitte bald nochmals probieren.',
            otherModelButton: 'Mit mehr Kontext versuchen (Experimentell)',
            wasItUseful: 'War die Antwort hilfreich?',
            yes: 'Ja',
            no: 'Nein',
            giveFeedback: 'Feedback geben',
            readHints: 'Hinweise und Einschränkungen lesen',
            letsTryToImprove: 'Lass uns versuchen, die Antwort zu verbessern!',
            improvePrompt: 'Frage verfeinern und nochmals probieren',
            thanksForFeedback: 'Danke für Ihr Feedback!',
            happy: 'Zufrieden mit der Antwort',
            unhappy: 'Unzufrieden mit der Antwort',
            not_considered_articles: 'Für die Antwort nicht berücksichtigte Links (aber evt. doch relevant):',
            considered_articles: 'Für die Antwort berücksichtigte Links:',
            answer: 'Antwort',
            searchresults: 'Suchresultate',
          },
          conditions: {
            mainTitle: 'Nutzungsbedingungen und Datenschutzerklärung',
            title: 'Nutzungsbedingungen',
            intro:
              'Diese Applikation wurde entwickelt, um Ihnen bei allgemeinen Fragen zur Verwaltungstätigkeit des Kantons Basel-Stadt zu helfen. Die Antworten werden von einer künstlichen Intelligenz generiert und sind deshalb nicht immer korrekt und vollständig. Bitte lesen Sie vorgängig die Nutzungsbedingungen sowie die Datenschutzerklärung. Durch die Nutzung der Applikation erklären Sie sich mit den Nutzungsbedingungen und der Datenschutzerklärung einverstanden. Wir freuen uns über jedes Feedback. ',
            note1:
              'Alva dient dazu, der Bevölkerung allgemeine Informationen zu öffentlich zugänglichen Inhalten des Kantons Basel-Stadt zur Verfügung zu stellen. Sie bietet eine erste Anlaufstelle für häufig gestellte Fragen und allgemeine Informationen.',
            note2:
              'Der Kanton Basel-Stadt übernimmt keine Gewähr für die Richtigkeit, Vollständigkeit oder Aktualität der von Alva zu Verfügung gestellten Informationen. Die Informationen dienen lediglich zu allgemeinen Informationszwecken und sind rechtlich nicht bindend. Wir bitten Sie, die von Alva zu Verfügung gestellten Informationen auf den offiziellen Websites des Kantons zu überprüfen.',
            note3:
              'Alva basiert auf künstlicher Intelligenz und kann daher Fehler machen oder ungenaue Informationen bereitstellen. Insbesondere können Antworten korrekt erscheinen, inhaltlich jedoch falsch sein. Für die Folgen, die aus der Nutzung der von Alva bereitgestellten Informationen resultieren, wird vom Kanton Basel-Stadt keine Haftung übernommen.',
            note4:
              'Bei Fragen, die persönliche oder spezifische Informationen betreffen, wenden Sie sich bitte direkt an die zuständige Dienststelle. Alva ist nicht in der Lage, auf persönliche oder vertrauliche Anfragen angemessen zu reagieren. ',
            note5:
              'Die Nutzung von Alva ist ausschliesslich für legale Zwecke gestattet. Ein Missbrauch des Dienstes, insbesondere für rechtswidrige Handlungen oder zur Verbreitung von schädlichen Inhalten, ist strengstens untersagt.',
            note6:
              'Zur Verbesserung der Applikation werden Ihre Fragen sowie die Antworten von Alva gespeichert und im Hintergrund ausgewertet. Ihre Fragen werden zudem von Alva über eine Schnittstelle an ChatGPT von OpenAI gesendet. Durch die Verwendung der Applikation erklären Sie sich mit diesem Vorgehen als einverstanden. ',
            note7:
              'Der Kanton Basel-Stadt behält sich das Recht vor, diese Nutzungsbedingungen jederzeit anzupassen. Anpassungen werden auf dieser Seite veröffentlicht und es liegt in der Verantwortung des Nutzers, sich über solche Anpassungen zu informieren.',
            note8:
              'Bitte wenden Sie sich für weitere Informationen oder Fragen zu diesen Nutzungsbedingungen an [internet.it@bs.ch](mailto:internet.it@bs.ch). ',
          },
          privacy: {
            title: 'Datenschutzerklärung',
            note1:
              'Verantwortlich für die Datenverarbeitung im Rahmen der Nutzung von Alva ist: [internet.it@bs.ch](mailto:internet.it@bs.ch) Kanton Basel-Stadt, IT BS, Spiegelasse 4, 4051 Basel. Bitte kontaktieren Sie uns bei Fragen zu dieser Datenschutzerklärung oder der Verarbeitung Ihrer Personendaten.',
            note2:
              'Alva verarbeitet die Informationen, die Sie im Rahmen Ihrer Nutzung bereitstellen. Dazu gehören die von Ihnen eingegebenen Fragen und Antworten. Alva kann Personendaten erfassen und verarbeiten, wenn diese von Nutzenden im Chat eingegeben werden.',
            note3:
              'Personendaten, die von Nutzenden über die Feedbackfunktion bekannt gegeben werden, werden gespeichert. Diese Daten werden verwendet, um unseren Service zu pflegen, zu verbessern sowie mit Ihnen zu kommunizieren.',
            note4:
              'Alva basiert auf der LLM-Technologie (Large Language Models) des US-amerikanischen Softwareunternehmens OpenAI. Informationen, einschliesslich Personendaten, die Sie uns über die Chatfunktion zu Verfügung stellen, werden an OpenAI weitergegeben, um uns bei der Bereitstellung unserer Dienste zu helfen.',
            note5: 'Als Nutzer bzw. als Nutzerin von Alva haben Sie das Recht:',
            note5_1: 'Auskunft über die von uns verarbeiteten Personendaten zu verlangen;',
            note5_2: 'Die Berichtigung unrichtiger Daten zu verlangen;',
            note5_3:
              'Die Löschung Ihrer Personendaten zu verlangen, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen;',
            note5_4: 'Die Einschränkung der Datenverarbeitung zu verlangen.',
            note5_foot: 'Bitte richten Sie entsprechende Anfragen an [internet.it@bs.ch](mailto:internet.it@bs.ch).',
            note6:
              'Zur Verbesserung der Applikation werden Ihre Fragen sowie die Antworten von Alva gespeichert und im Hintergrund ausgewertet. Ihre Fragen werden zudem von Alva über eine Schnittstelle an ChatGPT von OpenAI gesendet. Durch die Verwendung der Applikation erklären Sie sich mit diesem Vorgehen als einverstanden. ',
            note7:
              'Der Kanton Basel-Stadt behält sich das Recht vor, diese Nutzungsbedingungen jederzeit anzupassen. Anpassungen werden auf dieser Seite veröffentlicht und es liegt in der Verantwortung des Nutzers, sich über solche Anpassungen zu informieren.',
          },
          contact: {
            title: 'Kontakt und Feedback',
            emailLabel: 'Ihre E-Mail (optional):',
            messageLabel: 'Ihre Nachricht:',
            submitButton: 'Abschicken',
            feedbackReceived: 'Feedback erhalten, danke!',
            feedbackReceivedError: 'Da ist was schief gelaufen, bitte kontaktiere uns auf anderen Wegen.',
            emailText: 'Oder senden Sie eine Mail an chregu@liip.ch',
            moreContact: 'Mehr Kontaktmöglichkeiten auf',
          },
          footer: {
            credits: 'Powered by <1>Liip</1> — <3>Blog Post über das Projekt</3>',
            disclaimer: `Alle Angaben ohne Gewähr. Bitte überprüfen Sie die Informationen auf der offiziellen Webseite des Kantons Basel-Stadt.`,
            selectLanguage: 'Sprache auswählen',
          },
        },
      },
      fr: {
        translation: {
          header: {
            title: `${import.meta.env.VITE_SITE_NAME}`,
            slogan: `Je m'appelle Alva. Je donne des informations sur le contenu de <1>${import.meta.env.VITE_MAIN_SITE_SHORT}</1>`,
            intro: `
            Mes réponses sont générées par une intelligence artificielle et ne sont donc pas toujours correctes. Vos retours m'aident à m'améliorer.
            <br /><br />Nous apprécions donc tous vos <1>feedbacks.</1>`,
          },
          from: 'du',

          question: {
            label: 'Votre Question',
            placeholder: "Demandez-moi tout ce que vous voulez savoir sur l'administration de la canton de Bâle-Ville.",
            buttonText: 'Poser la question',
            microphoneLabel: 'Poser la question (avec microphone)',
            microphoneListening: 'Microphone: Maintenez le bouton enfoncé et parlez',
          },
          answers: {
            oneMoment: "Un moment s'il vous plaît... ",
            serverConnectionError: 'Connexion au serveur interrompue :( Veuillez réessayer bientôt.',
            otherModelButton: 'Essayez avec plus de contexte (expérimental)',
            wasItUseful: 'La réponse vous était utile?',
            yes: 'Oui',
            no: 'Non',
            giveFeedback: 'Donner un feedback',
            readHints: 'Lire les astuces et limitations',
            letsTryToImprove: 'Essayons d’améliorer les choses!',
            improvePrompt: 'Affiner la question et réessayer',
            thanksForFeedback: 'Merci pour votre feedback!',
            happy: 'Satisfait de la réponse',
            unhappy: 'Insatisfait de la réponse',
            not_considered_articles:
              'Liens non pris en compte pour la réponse (mais éventuellement toujours pertinents):',
            considered_articles: 'Liens pris en compte pour la réponse:',
            answer: 'Réponse',
            searchresults: 'Résultats de recherche',
          },
          hints: {
            title: 'Astuces et Limitations',
            notesTitle: 'Astuces',
            intro:
              'Diese Applikation wurde entwickelt, um Ihnen bei allgemeinen Fragen zur Verwaltungstätigkeit des Kantons Basel-Stadt zu helfen. Die Antworten werden von einer künstlichen Intelligenz generiert und sind deshalb nicht immer korrekt und vollständig. Bitte lesen Sie vorgängig die Nutzungsbedingungen sowie die Datenschutzerklärung. Durch die Nutzung der Applikation erklären Sie sich mit den Nutzungsbedingungen und der Datenschutzerklärung einverstanden. Wir freuen uns über jedes Feedback. ',
            note1: 'Ceci est une version expérimentale de cette application, qui est continuellement améliorée.',
            note2: 'Toutes les informations sont fournies sans garantie.',
            note3:
              "Veuillez vérifier les informations d'Alva sur les sites officiels du Canton de Bâle-Ville [www.bs.ch](http://bs.ch).",
            note4:
              "Alva envoie vos questions via une interface à ChatGPT d'OpenAI. Si vous avez des préoccupations concernant la confidentialité des données, veuillez vous abstenir d'utiliser l'assistant.",
            note5:
              'Alva ne peut pas aborder votre situation individuelle mais génère des réponses basées sur le contenu publiquement accessible du Canton de Bâle-Ville. Pour des informations personnelles, veuillez contacter le personnel du Canton.',
            note6:
              'Alva ne se souvient pas des questions précédemment posées. Pour des précisions, la question doit être saisie à nouveau.',
            note7:
              'Il est préférable de poser des questions complètes plutôt que de simplement entrer des mots-clés. Parfois, reformuler une question peut aider à obtenir une meilleure réponse.',
            note8: "Si aucune réponse n'est fournie ou si la réponse s'interrompt brusquement, veuillez réessayer.",
            note9:
              "Nous travaillons continuellement à l'amélioration de cette application. Par conséquent, nous enregistrons vos questions et réponses et les évaluons en arrière-plan.",
            note10: 'Nous apprécions grandement tout retour que vous fournissez ; cela nous aide énormément.',
            note11: '[Politique de confidentialité](/privacy)',
            limitationsTitle: 'Limitations',
            limitationsText: `Alva sait (presque) tout ce qui a été publié sur <1>${
              import.meta.env.VITE_MAIN_SITE_SHORT
            }</1> à la date du {{lastUpdate}}.`,
            disclaimerText:
              "Les réponses d'Alva ne sont pas juridiquement contraignantes et il n'y a aucune garantie quant à l'exactitude, la complétude ou l'actualité des informations fournies.",
          },
          contact: {
            title: 'Contact et Commentaires',
            emailLabel: 'Votre E-Mail :',
            messageLabel: 'Votre message :',
            submitButton: 'Envoyer',
            feedbackReceived: 'Merci pour votre message!',
            feedbackReceivedError: 'Quelque chose s’est mal passé, veuillez nous contacter par d’autres moyens.',
            emailText: 'Ou envoyez un email à chregu@liip.ch',
            moreContact: "Plus d'options de contact sur",
          },
          footer: {
            credits: 'Propulsé par <1>Liip</1> — <3>Article sur le projet</3>',
            disclaimer: `Toutes les informations sont fournies sans garantie. Veuillez vérifier les informations sur le site officiel de la ville de Bâle.`,
            selectLanguage: 'Sélectionner la Langue',
          },
        },
      },
    },
  })

export default i18n
